/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProductSelectionState } from '@pdp/data-access/interfaces';

export const selectState = createFeatureSelector<ProductSelectionState>('productSelection');

export const selectWarrantiesState = createSelector(selectState, (state) => state?.warranties);

export const selectSelectedWarrantyDisplayName = createSelector(
	selectWarrantiesState,
	(state) => state?.selectedWarranty?.displayName
);
